import React, { Component } from 'react'
import { SearchBarTable } from 'hljd'
import getColumns from './columns'
import { inject } from 'mobx-react'

@inject('store')
export default class extends Component {
  render() {
    return (
      <SearchBarTable
        store={this.props.store}
        columns={getColumns(this.props.store)}
        showHeader={false}
      />
    )
  }
}
